import {
	ADMINGETFEEDEFAULTVALUES_SUCCESS,
	ADMINGETFEEDEFAULTVALUES_FAILED,
	RESET_ADMINGETFEEDEFAULTVALUES,
	LOADING_ADMINGETFEEDEFAULTVALUES,
	NETWORK_ERROR_ADMINGETFEEDEFAULTVALUES
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {}
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_ADMINGETFEEDEFAULTVALUES:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {}
			};
		case ADMINGETFEEDEFAULTVALUES_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload
			};
		case ADMINGETFEEDEFAULTVALUES_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload
			};
		case NETWORK_ERROR_ADMINGETFEEDEFAULTVALUES:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {}
			};
		case RESET_ADMINGETFEEDEFAULTVALUES:
			return (state = initialState);
		default:
			return state;
	}
};
